<template>
    <div>

        <main class="d-flex justify-content-center inicio-home">
            <div class="container p-5">
                <div class="row d-flex justify-content-center">
                    <div class="col-md-8  bg-body rounded shadow-sm p-5">
                       <div class="d-flex justify-content-between">
                             <h3 >Mis cuentas bancarias</h3>
                             <p><a @click="agregarBankCl">Agregar</a></p>
                        </div>
                       <hr>
                       <div v-if="isLoad">
                        <div class="d-flex justify-content-between" v-for="(linea,index) in cuentasBancarias" :key="index">
                            <div class="col-md-6 d-flex justify-content-start">
                                <ul class="list-ope">
                                    <li class="item-op-1" v-text="linea.NombreCuenta"></li>
                                    <li class=""><span v-text="linea.NombreBanco"></span></li>
                                    <li class="" v-text="linea.NombreTipoCuenta"></li>
                                </ul>
                            </div>
                            <div class="col-md-6 d-flex justify-content-end">
                                <ul class="list-ope">
                                    <li class="item-op-1" align="right"><a @click="$router.push({name:'EditarCuentasBancarias', params:{id: linea.IdBancoCliente}}).catch(err => {})">Editar <i class="far fa-edit"></i></a>
                                    &nbsp;<a @click="eliminarCuentaPopap(linea.IdBancoCliente)">Eliminar <i class="far fa-trash-alt"></i></a>
                                    </li>
                                    <li class="" align="right" v-text="linea.NumeroCuenta"></li>
                                    <li class="" align="right" > <span v-text="linea.NombreMoneda"></span></li>   
                                </ul>
                            </div>
                            <hr>
                        </div>
                       </div>
                        <div  class="cargando" v-if="!isLoad"></div>
                        
                    </div>
                </div>
            </div>
        </main>
        
        <!-- Modal Agregar Cuenta Banco-->
        <div class="modal fade" id="ag-cuenta-banco" tabindex="-1" aria-labelledby="ag-cuenta-bancoLabel" aria-hidden="true">
            <div class="modal-dialog">
            <div class="modal-content">
              <div class="m">
                <button type="button" class="btn-close float-end" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
                <div class="modal-body">
                    <h2 class="titulo-registro text-center">Agregar tu cuenta bancaria</h2>

                         <div class="col-md-12 m-t-2">
                        <label for="" class="form-label">Titular de la cuenta</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.TitularCuenta" >
                            <option selected>{{nombreCompleto}}</option>
                          </select>  
                        </div>

                       <div class="col-md-12 m-t-2">
                        <label for="firstName" class="form-label">Ponle un alias a tu cuenta</label>
                        <input type="text" class="form-control" id="firstName"  v-model="registerForm.NombreCuenta" required>
                      </div>
                      <div class="col-md-12 m-t-2">
                        <label for="" class="form-label">Banco</label>
                        <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoBanco">
                            <option v-for="(linea,index) in selectBank" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                
                          </select>  
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="" class="form-label">Tipo de cuenta</label>
                            <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoCuenta">
                                <option v-for="(linea,index) in selectTipoC" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                            </select>  
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="" class="form-label">Moneda</label>
                            <select class="form-select" aria-label="Default select example" v-model="registerForm.IdTipoModena">
                                <option v-for="(linea,index) in selectTipoMo" :key="index" :value="linea.Id" v-text="linea.NombreParametroValor" ></option>
                
                              </select>  
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="firstName" class="form-label">Número de tu cuenta</label>
                            <input type="text" class="form-control" id="firstName"   v-model="registerForm.NumeroCuenta" @keypress="limiteCaracteres('NumeroCuenta', $event)" required>
                        </div>
                        <div class="col-md-12 m-t-2">
                            <label for="firstName" class="form-label">Número de tu cuenta interbancaria</label>
                            <input type="text" class="form-control" id="firstName"   v-model="registerForm.CCI" @keypress="limiteCaracteres('CCI', $event)" >
                        </div><br>

                        <p class="text-center">Podrás registrar otras cuentas más adelante en el módulo "Cuentas"</p>

                        <button class="w-100 btn btn-lg btn btn-registro" @click="registrarCuenta">Registrar cuenta</button>
                </div>
               
            </div>
            </div>
        </div><!-- Modal -->

        <!-- Modal Eliminar Cuenta Banco-->
        <div class="modal" tabindex="-1" id="modalMensajeEliminarBanco">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <p><span>¿Esta seguro de Eliminar esta Cuenta?</span></p>
                        <p>Nota: No se podrán eliminar las cuentas que hayan tenido alguna transferencia</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-eliminar" @click="eliminarCuenta">Eliminar</button>
                        <button type="button" class="btn btn-cancelar" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
    </div>
</template>
<script>
    import auth from '@/services/auth'
    import helpers from '@/services/helpers'
    
      export default {
        name: "Perfil",
    
        data() {
        return {
          IdParaBancoCliente: 0,
          nombreCompleto:localStorage.getItem("nombreUsuario"),
          cuentasBancarias:[],
          registerForm:{
            TitularCuenta:"",
            NombreCuenta:"",
            IdTipoBanco: "",
            IdTipoCuenta: "",
            IdTipoModena: "",
            NumeroCuenta: "",
            CCI: "",
        },
        selectBank:[],
        selectTipoC:[],
        selectTipoMo:[],
        isLoad:false,
        };
      },
    
      beforeCreate(){
        helpers.actualizarTipoCambio(this);
        auth.listarBancoCliente(this).then(response => {
          this.cuentasBancarias=response;
          this.isLoad=true;
        });

        auth.listParameters().then(response => {
            this.selectBank=response.ParametrosGenerales.filter(e=>e.IdParametro=="BANC");
            this.selectTipoC=response.ParametrosGenerales.filter(e=>e.IdParametro=="TICU");
            this.selectTipoMo=response.ParametrosGenerales.filter(e=>e.IdParametro=="TIMO");
      });
      },
      methods:{
          
        agregarBankCl(){
            $('#ag-cuenta-banco').modal('show');
        },
        registrarCuenta(){
        if(this.registerForm.NombreCuenta!="" && this.registerForm.NumeroCuenta!=""){
           
            if (auth.registerBankClientCuenta(this)){
                this.limpiarRegitrarCuenta();
                $('#ag-cuenta-banco').modal('hide');
                
                // Actualizar listado
                helpers.actualizarTipoCambio(this);
                auth.listarBancoCliente(this).then(response => {
                this.cuentasBancarias=response;
                this.isLoad=true;
                });

                auth.listParameters().then(response => {
                    this.selectBank=response.ParametrosGenerales.filter(e=>e.IdParametro=="BANC");
                    this.selectTipoC=response.ParametrosGenerales.filter(e=>e.IdParametro=="TICU");
                    this.selectTipoMo=response.ParametrosGenerales.filter(e=>e.IdParametro=="TIMO");
                });

           }
        }
        else{
            toastr["error"]("Ingrese nombre y número de Cuenta");
        }
        },
        eliminarCuenta(){

                auth.eliminarBancoCliente(this.IdParaBancoCliente)
                .then((response) => {
                    this.IdParaBancoCliente=0;
                    $('#modalMensajeEliminarBanco').modal('hide'); 
                    // Actualizar listado
                    helpers.actualizarTipoCambio(this);
                    auth.listarBancoCliente(this).then(response => {
                    this.cuentasBancarias=response;
                    this.isLoad=true;
                    });
                    //console.log(this.cuentasBancarias);
                    auth.listParameters().then(response => {
                        this.selectBank=response.ParametrosGenerales.filter(e=>e.IdParametro=="BANC");
                        this.selectTipoC=response.ParametrosGenerales.filter(e=>e.IdParametro=="TICU");
                        this.selectTipoMo=response.ParametrosGenerales.filter(e=>e.IdParametro=="TIMO");
                    });

                })
                .catch((error) => {

                });
     
        },
        eliminarCuentaPopap(id){
            this.IdParaBancoCliente=id;
            $('#modalMensajeEliminarBanco').modal('show');
        },
        limpiarRegitrarCuenta(){
            this.registerForm.NombreCuenta="";
            this.registerForm.IdTipoBanco="";        
            this.registerForm.IdTipoCuenta="";
            this.registerForm.IdTipoModena="";
            this.registerForm.NumeroCuenta=""; 
            this.registerForm.CCI="";  
        },
        limiteCaracteres(val, $event){
            helpers.limiteCaracteres($event, this.registerForm[val], 25 );
            helpers.soloNumeros($event);
        },
      },
      };
      </script>


// WEBPACK FOOTER //
// src/components/user/CuentasBancarias.vue